import React from 'react'

import './styles.scss'

const Card = ({ title, description, children }) => {
  return (
    <div className="card-view">
      <div className="card-view__header">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
      <div className="card-view__content">{children}</div>
    </div>
  )
}

export default Card
